// utils/api.js
import { UrlDev } from "../url";
import { getCookie } from "../utils/cookies";

const handleAuthError = () => {
  localStorage.removeItem('token');
  sessionStorage.removeItem('token');
  window.dispatchEvent(new Event("logout"));
};
export const authFetch = async (url) => {
    const token = getCookie("access_token");

    if (!token) {
      handleAuthError();
      throw new Error("No authentication token found");
    }

    const response = await fetch(`${UrlDev}${url}`, {
        headers: {
            "Authorization": `Bearer ${token}`,
            "Accept": "application/json"
        },
        credentials: "include"
    });

    if (response.status === 401) {
        window.dispatchEvent(new Event("logout"));
        throw new Error("Session expired");
    }

    return response.json();
};

export const authFetchRequest = async (url, payload = null, method = "POST", customHeaders = {}) => {
    const token = getCookie("access_token");
  
    if (!token) {
      handleAuthError();
      throw new Error("No authentication token found");
    }
  
    const csrfToken = localStorage.getItem("csrf_token");
    if (!csrfToken) {
      throw new Error("No CSRF token found");
    }
  
    const headers = {
      "Content-Type": "application/json",
      "X-CSRF-TOKEN": csrfToken,
      ...customHeaders,
    };
  
    const options = {
      method,
      headers,
      credentials: "include",
    };
  
    // Only attach body if method allows it
    if (payload && method !== "GET" && method !== "DELETE") {
      options.body = JSON.stringify(payload);
    }
  
    const response = await fetch(`${UrlDev}${url}`, options);
  
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Server error ${response.status}: ${errorText}`);
    }
  
    // DELETE often returns empty body
    if (method === "DELETE") {
      return { success: true };
    }
  
    return await response.json();
  };
  


